import React, { Component } from 'react';

export default class FolioCellRenderer extends Component {
  render() {
    const { data } = this.props;
    return (
      <div style={{ lineHeight: '20px' }}>
        {data.folio !== undefined
          ? data.folio
          : data.prefolio !== undefined
          ? data.prefolio
          : data.folio}
       
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CellRenderer/FolioCellRenderer.jsx